

export default function ExperienceSection() {
  return (
    <section id="experiencia" className="py-16 md:py-24 bg-[#0d1a2a]">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-[#14253D]/50 border border-white/8 rounded-[24px] md:rounded-[30px] p-6 md:p-8">
            <div className="w-12 h-12 md:w-14 md:h-14 bg-[#B89A5A]/15 rounded-2xl flex items-center justify-center mb-4 md:mb-5">
              <i className="ri-award-line text-xl md:text-2xl text-[#B89A5A]"></i>
            </div>
            <h3 className="text-white text-base md:text-lg font-bold mb-2 md:mb-3">
              Enfoque en Resultados
            </h3>
            <p className="text-white/60 text-sm md:text-base leading-relaxed">
              Experiencia profesional aplicada a la resolución efectiva de conflictos.
            </p>
          </div>

          <div className="bg-[#14253D]/50 border border-white/8 rounded-[24px] md:rounded-[30px] p-6 md:p-8">
            <div className="w-12 h-12 md:w-14 md:h-14 bg-[#B89A5A]/15 rounded-2xl flex items-center justify-center mb-4 md:mb-5">
              <i className="ri-team-line text-xl md:text-2xl text-[#B89A5A]"></i>
            </div>
            <h3 className="text-white text-base md:text-lg font-bold mb-2 md:mb-3">
              Atención Personalizada
            </h3>
            <p className="text-white/60 text-sm md:text-base leading-relaxed">
              Acompañamiento directo y seguimiento permanente de cada caso.
            </p>
          </div>

          <div className="bg-[#14253D]/50 border border-white/8 rounded-[24px] md:rounded-[30px] p-6 md:p-8">
            <div className="w-12 h-12 md:w-14 md:h-14 bg-[#B89A5A]/15 rounded-2xl flex items-center justify-center mb-4 md:mb-5">
              <i className="ri-scales-3-line text-xl md:text-2xl text-[#B89A5A]"></i>
            </div>
            <h3 className="text-white text-base md:text-lg font-bold mb-2 md:mb-3">
              Compromiso Ético
            </h3>
            <p className="text-white/60 text-sm md:text-base leading-relaxed">
              Profesionalismo y transparencia en cada proceso legal.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
